export const userDetails = (...additionalInfo: string[]): string => {
  return "{\n" + additionalInfo.join("\n") + "}";
};

export const genQuery = (
  buid: string,
  empGuid: string,
  start?: number,
  end?: number,
  types?: string[],
  meetingRoomBookingsRequired?: boolean,
  cancelFlag?: boolean,
  pageNo?: number,
  pageSize?: number
) => {
  const query = 'getEmployee(where : {buid:"' + buid + '", empGuid:["' + empGuid + '"]';
  return (
    query +
    (start ? ", startDateBooking: " + start : "") +
    (end ? ", endDateBooking: " + end : "") +
    (types?.length > 0 ? ", bookingTypes: " + `["${types.join('","')}"]` : "") +
    (meetingRoomBookingsRequired ? ", meetingRoomBookingsRequired: " + meetingRoomBookingsRequired : "") +
    (types?.length ? ", includeCancelledBookings: " + cancelFlag : "") +
    "}" +
    (pageNo ? ", pageNo : " + pageNo : "") +
    (pageSize ? ", pageSize : " + pageSize : "") +
    ")"
  );
};

export const createQuery = (filter, body): string => {
  return `{${filter}${body}}`;
};
